export default function isValidUSZipCode(zip) {
  const zipCodePattern = /^\d{5}(-\d{4})?$/;
  return zipCodePattern.test(zip);
}
